<template>
  <div>
    <p class="extra-season-name">{{ selectedName }}</p>
    <v-radio-group v-model="newSelectedProduct.extra_season_override" dense @change="saveExtraSeasonOverride" class="custom-radio-group">
      <div class="radio-row">
        <v-radio v-for="choice in extraSeasonChoices.slice(0, 2)" :key="choice.value" :label="choice.text"
          :value="choice.value" dense>
        </v-radio>
      </div>
      <div class="radio-row">
        <v-radio v-for="choice in extraSeasonChoices.slice(2)" :key="choice.value" :label="choice.text"
          :value="choice.value" dense>
        </v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
// Wrapper component to edit row or selectedproduct comments.

// EditComment will handle api call to persist data

import { modifyObj } from "../utils/utils";
import SelectedProductsEdit from "./SelectedProductsEdit.vue";

export default {
  name: "EditExtraSeasonOverride",

  mixins: [SelectedProductsEdit],

  props: {
    selectedProducts: {
      type: Array,
    },
    choices: {
      type: Object,
    },
    order: {
      type: Object,
    },
  },

  data: () => ({
    dialog: false,
  }),

  methods: {
    saveExtraSeasonOverride() {
      this.saveSelectedProducts();
    },
  },

  computed: {
    selectedName() {
      for (let season of (this.choices || {}).extra_seasons || []) {
        if (season.id === this.newSelectedProduct.extra_season_override) {
          return season.name;
        }
      }
      if (this.order.default_extra_season) {
        const defaultSeason = (this.choices.extra_seasons || []).find(
          (s) => s.id === this.order.default_extra_season
        );
        return defaultSeason?.name || "Ei määritetty";
      }
      return "Ei määritetty";
    },
    extraSeasonChoices() {
      const ret = [];
      const parseName = (name) => {
        if (!name) return "None";
        // if name is like A-luokka, return just A
        const parts = name.split("-");
        if (parts.length > 1) {
          return parts[0];
        }
        return name;
      };
      if (this.order.default_extra_season) {
        // Find the name of the default extra season
        const defaultSeason = (this.choices.extra_seasons || []).find(
          (s) => s.id === this.order.default_extra_season
        );
        if (defaultSeason) {
          ret.push({
            text: `Oletus (${parseName(defaultSeason.name)})`,
            value: null,
          });
        }
      }
      if (ret.length === 0) {
        ret.push({
          text: "",
          value: null,
        });
      }
      for (let season of (this.choices || {}).extra_seasons || []) {
        if ((season.name || "").toLowerCase().includes("tyhjä")) {
          ret.push({
            text: "Tyhjä",
            value: season.id,
          })
          continue;
        }
        ret.push({
          text: parseName(season.name),
          value: season.id,
        });
      }
      // Use code as text if it is not null
      return ret.map(season => ({
        text: season.code || season.text,
        value: season.value,
      }));
    },
  },
};
</script>

<style scoped>
.notice {
  color: #ff9500 !important;
  border: 1rem solid #fffa47;
  border-radius: 0.5rem;
}

/* Reduce space between radio button and label */

:deep(.v-input--selection-controls__input) {
  margin-right: 1px !important;
}

/* Custom radio group layout */
.custom-radio-group .radio-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

:deep(.custom-radio-group .v-input__control) {
  width: 100%;
}

:deep(.custom-radio-group .v-input--radio-group__input) {
  flex-direction: column !important;
}

:deep(.custom-radio-group .v-radio) {
  align-items: center;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.extra-season-name {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.custom-radio-group {
  margin-top: 0 !important;
}
</style>
